<template>
	<div class="az-text arp-label-personalizado">
		<label>{{ nomeCampo }} </label>
		<span v-if="obrigatorioPorPadrao" class="red--text">*</span>
		<tooltip-informativo
			v-if="apresentaTooltip"
			id="tooltipInformativo"
			:mensagemPadraoTooltip="mensagemPadraoTooltip"
		></tooltip-informativo>
	</div>
</template>

<script>
export default {
	name: 'label-personalizado',
	components: {},
	props: {
		apresentaTooltip: {
			type: Boolean,
		},
		nomeCampo: {
			type: String,
			required: true,
		},
		obrigatorioPorPadrao: {
			type: Boolean,
		},
		mensagemPadraoTooltip: {
			type: String,
			default: 'mensagem',
		},
	},
}
</script>
<style lang="stylus">
.arp-label-personalizado
	font-size 14px
	font-weight: bold
</style>
